import React from "react";
import { Link } from "react-router";
import SecondaryButton from "../buttons/SecondaryButton";

export const EditTrialsBackButton = ({ editLocation, editTrial, classes }) => {
  return (
    <Link to="/trials">
      <SecondaryButton label="Cancel" classes={classes}></SecondaryButton>
    </Link>
  );
};
